import { render, staticRenderFns } from "./alipayPool.vue?vue&type=template&id=806de1ca&"
import script from "./alipayPool.vue?vue&type=script&lang=js&"
export * from "./alipayPool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports